import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskIban'
})
export class MaskIbanPipe implements PipeTransform {

  transform(value: string): string | null {
    let result = '';
    if (value) {
      if (value.length > 6) {
        for (let i=0; i<value.length-6; i++) {
          result += '*';
        }
        result += value.substring(value.length-6);
      }
      else {
        return value;
      }
    }
    else {
      return value;
    }
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/shared/pipes/maskIban.pipe.ts